import { token } from '@cp/shared/di';
import { ClientRegistrationState } from '@common/model/client/registration';
import { AsyncResult } from '@youhelp-ru/core';

export const LOGIN_FEATURE_TOKEN =
  token<(clientSelection?: Partial<ClientRegistrationState>) => AsyncResult<unknown, Error>>('Login feature');
